import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

interface SnackBarOptions {
  message: string;
  duration?: number;
  action?: string;
  panelClass?: string;
}

@Injectable({
  providedIn: "root"
})
export class SnackBarService {
  private defaultOptions: SnackBarOptions = { message: null, duration: 2000 };
  constructor(private snackBar: MatSnackBar) {}

  show(options: SnackBarOptions) {
    options = { ...this.defaultOptions, ...options };

    this.snackBar.open(options.message, options.action, {
      duration: options.duration,
      panelClass: options.panelClass
    });
  }
}
